import { RuntimeHomeScreen } from '@/features/unified-learning/runtime/screens/RuntimeHomeScreen';

export default function LearnPathHomeRoute() {
  return <RuntimeHomeScreen runtimeBase="/learn/path" />;
}
